import ToolLandingTemplate from '../../components/landing/ToolLandingTemplate';
import { LIVE_TOOLS } from '../../data/tools';
import { resumeBuilderLanding } from '../../content/resumeBuilderContent';

const tool = LIVE_TOOLS.find((t) => t.id === 'resume-builder');

export default function ResumeBuilderLanding() {
  return <ToolLandingTemplate tool={tool} {...resumeBuilderLanding} />;
}
